export const isInstagramUrl = (url: string) => /^https:\/\/(www\.)?instagram\.com\/.+/i.test(url);
